<template>
  <component class="DutiesView" :moduleConfig="mx_moduleConfig" :is="mx_moduleFlavour"></component>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import DutyList from '@/modules/myDuties/views/DutiesOverview.vue';
import DutyCalendarRhbStyle from './DutyCalendarRhbStyle';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';

export default {
  name: 'DutiesView',
  mixins: [common, configMixin, dutyMixin],

  components: {
    DutyList,
    DutyCalendarRhbStyle,
  },
};
</script>
